import { toAbsoluteUrl } from "_metronic/utils/utils";

export const initLayoutConfig = {
  demo: "demo1",
  // == Base Layout
  self: {
    layout: "fluid",
    // body: { "background-image": toAbsoluteUrl("/media/misc/bg-1.jpg") },
    logo: {
      dark: toAbsoluteUrl("media/logos/LOGO.svg"),
      light: toAbsoluteUrl("media/logos/LOGO.svg"),
      brand: toAbsoluteUrl("media/logos/LOGO.svg"),
      green: toAbsoluteUrl("media/logos/LOGO.svg"),
    },
  },
  // == Portlet Plugin
  // portlet: {
  //   sticky: {
  //     offset: 50
  //   }
  // },
  // == Page Splash Screen loading
  loader: {
    enabled: true,
    type: "spinner-logo",
    logo: toAbsoluteUrl("/media/logos/logo-mini-md.png"),
    message: "Please wait...",
  },
  // == Colors for javascript
  colors: {
    state: {
      brand: "#2e5bff",
      dark: "#282a3c",
      light: "#ffffff",
      primary: "#5867dd",
      success: "#2cc2a5",
      info: "#5578eb",
      warning: "#fa9917",
      danger: "#ff5f58",
    },
    base: {
      label: ["#bdbdbd", "#8798ad", "#5f6c72", "#2e384d"],
      shape: ["#f0f3ff", "#d9dffa", "#afb4d4", "#646c9a"],
    },
  },
  // page toolbar
  toolbar: {
    display: true,
  },
  header: {
    self: {
      width: "fluid", // fixed|fluid
      skin: "light",
      fixed: {
        desktop: true,
        mobile: true,
      },
    },
    menu: {
      self: {
        display: true,
        layout: "default",
        "root-arrow": false,
        "icon-style": "duotone",
      },
      desktop: {
        arrow: true,
        toggle: "click",
        submenu: {
          skin: "light",
          arrow: true,
        },
      },
      mobile: {
        submenu: {
          skin: "dark",
          accordion: true,
        },
      },
    },
  },
  subheader: {
    display: false,
    displayDesc: false,
    displayDaterangepicker: true,
    layout: "subheader-v1",
    fixed: true,
    width: "fluid", // fixed|fluid,
    clear: false,
    style: "solid",
  },
  content: {
    width: "fluid",
  },
  brand: {
    self: {
      skin: "light",
    },
  },
  aside: {
    self: {
      skin: "light",
      display: true,
      fixed: true,
      minimize: {
        toggle: true,
        default: false,
      },
    },
    footer: {
      self: {
        display: true,
      },
    },
    menu: {
      dropdown: "false",
      scroll: false,
      "icon-style": "duotone",
      submenu: {
        accordion: true,
        dropdown: {
          arrow: true,
          "hover-timeout": 100,
        },
      },
    },
  },
  footer: {
    self: {
      width: "fluid",
      fixed: false,
    },
  },
};

let LayoutConfig = JSON.parse(JSON.stringify(initLayoutConfig)); // deep object copy
export default LayoutConfig;
